<template>
	<div class="view-template">这是view页面的模板</div>
</template>

<script>
export default {
	name: 'viewTemplate',
	components: {},
	props: {},
	data() {
		return {}
	},
	computed: {},
	watch: {},
	methods: {},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
